import { useIntl } from 'react-intl';

import { XING_JOBS_MY_JOBS_PATH } from '@xing-com/crate-core-routes';
import { ActionSlot } from '@xing-com/crate-layout-top-bar';
import { IconBookmark } from '@xing-com/icons';

const MyJobsSlot: React.FC = () => {
  const { formatMessage } = useIntl();

  const label = formatMessage({ id: 'VERTICAL_NAV_YOUR_JOBS_LABEL' });

  return (
    <ActionSlot
      size="small"
      showLabel
      text={label}
      icon={IconBookmark}
      to={XING_JOBS_MY_JOBS_PATH}
      aria-label={label}
    />
  );
};

export const getPrimaryActions = (): React.ReactElement[] => {
  return [<MyJobsSlot key="1" />];
};
